<template>


    <div >



    </div>

</template>

<script>

    import {autologin } from   '../api/index';
    import {delCookie, getCookie} from "../api/common";
export default {
    name: "AutoLogin",
    data() {
        return{


        }
    },
    methods: {
        autologinFunc(){
            let o={};
            if((getCookie('uid')!=undefined&&getCookie('token')!=undefined)||(sessionStorage.uid!=undefined&&sessionStorage.token!=undefined)){
                o={uid:sessionStorage.uid||getCookie("uid"),token:sessionStorage.token||getCookie("token")}
            }else{
                o={uid:localStorage.uid||getCookie("uid"),token:localStorage.token||getCookie("token")}
            }
            autologin(o).then((res) => {
                if (res.data.status == 1) {
                    this.$store.dispatch('saveFaceimg',res.data.obj.faceimg);
                    this.$store.dispatch('saveLogininfo',JSON.stringify(res.data.obj));
                    this.$store.dispatch('saveUname',res.data.obj.uname);

                    if(localStorage.autologin==1){
                        localStorage.uid=res.data.obj.uid;
                        localStorage.token=res.data.obj.token;
                    }


                    sessionStorage.uid=res.data.obj.uid;
                    sessionStorage.token=res.data.obj.token;



                    if(res.data.obj.role=='1'||res.data.obj.role=='50'||res.data.obj.role=='100'){
                        let tol=sessionStorage.tol||getCookie("tol");

                        if( tol!=undefined){
                            this.$router.replace( tol);
                            sessionStorage.removeItem("tol");
                            delCookie("tol");
                        }
                        else this.$router.replace("/EntityList");
                    }else{
                        this.$router.replace("/tip");return;
                    }

                } else {
                    localStorage.removeItem("uid");
                    localStorage.removeItem("token");
                    localStorage.removeItem("autologin");

                    sessionStorage.removeItem("uid");
                    sessionStorage.removeItem("token");


                    this.$message.info('请登录账号')
                    this.$router.replace("/Login");
                }
            })
        }

    },mounted() {



        this.autologinFunc();




    }
};
</script>

<style scoped>


</style>
